module.exports = "<div [ngStyle]=\"locationCss\" class=\"container\">\r\n        <table>\r\n            <tr *ngFor=\"let item of items\" (click)=\"onClick(item)\">\r\n                <td style=\"width: 15px;\"><span class=\"glyphicon {{item.glyph}}\"></span></td>\r\n                <td style=\"width: 135px;\">{{item.text}}</td>\r\n            </tr>\r\n        </table>\r\n        \r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ContextMenu/contextMenu.component.html
// module id = 479
// module chunks = 1